import React from "react";
import { Typography } from "antd";
import BreakFilters from "./breakComponents/breakFilters";
import BreakTable from "./breakComponents/breakTable";
const { Title } = Typography;
const BreakList = () => {
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>Break</Title>
        </div>
        <div className="pch"></div>
      </div>
      <div className="p-content">
        <BreakFilters />
        <BreakTable />
      </div>
    </div>
  );
};
export default BreakList;
